import "../styles/Sidebar.css";
import { useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaChartBar,
  FaSignOutAlt,
  FaUnlink,
  FaStore,
  FaCreditCard,
  FaUser,FaCogs  ,
} from "react-icons/fa";
import logo from "../resources/sidebarLogo.png";
import mindscraft from "../resources/mindscraft-logo.png";
import { useAuth } from "../context/AuthContext";
import { clearUserData, getUserData } from "../utils/authStorage";

const Sidebar = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const userData = getUserData();

  const user = userData?.user || userData || {}; // handle both { user: {...} } and {...}

  const userType = user.user_type;
  const roles = Array.isArray(user.roles)
    ? user.roles.flat() // handles nested arrays like [['view-only']]
    : [];

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.removeItem("token");
      clearUserData();
      logout();
      navigate("/");
    }
  };

  /**
   * Determine what to show based on user type and roles
   */
  const getVisibleMenuItems = () => {
    // Admin — show all
    if (userType === "admin") {
      return [
        "dashboard",
        "reporting",
        "operations",
        "unbind",
        "merchants",
        "terminals",
        "hardpos",
        "inventory",
        "users",
      ];
    }

    // Subordinate — conditional based on roles
    if (userType === "subordinate") {
      // view-only => all access
      if (roles.includes("view-only")) {
        return [
          "dashboard",
          "reporting",
          "unbind",
          "merchants",
          "terminals",
          "hardpos",
          "inventory",
        ];
      }

      // merchant_onboarding only
      if (roles.length === 1 && roles.includes("merchant_onboarding")) {
        return ["dashboard", "reporting", "unbind", "merchants"];
      }

      // terminal_creation only
      if (roles.length === 1 && roles.includes("terminal_creation")) {
        return ["dashboard", "reporting", "unbind", "terminals"];
      }

      // combination of merchant_onboarding + terminal_creation
      if (
        roles.includes("merchant_onboarding") &&
        roles.includes("terminal_creation")
      ) {
        return [
          "dashboard",
          "reporting",
          "unbind",
          "merchants",
          "terminals",
          "hardpos",
          "inventory",
        ];
      }
    }

    // default (no access)
    return [];
  };

  const visibleItems = getVisibleMenuItems();

  const menuItems = [
    {
      key: "dashboard",
      label: "Dashboard",
      icon: <FaTachometerAlt />,
      path: "/dashboard",
    },
    {
      key: "reporting",
      label: "Reporting",
      icon: <FaChartBar />,
      path: "/dashboard/reporting",
    },
    {
      key: "unbind",
      label: "Unbind Terminal",
      icon: <FaUnlink />,
      path: "/dashboard/unbind",
    },
    {
      key: "operations",
      label: "Operations",
      icon: <FaCogs   />,
      path: "/dashboard/operations",
    },
    {
      key: "merchants",
      label: "Merchants",
      icon: <FaStore />,
      path: "/dashboard/merchantslist",
    },
    {
      key: "terminals",
      label: "Terminals",
      icon: <FaCreditCard />,
      path: "/dashboard/terminalslist",
    },
    {
      key: "hardpos",
      label: "Hard POS",
      icon: <FaCreditCard />,
      path: "/dashboard/hardpos",
    },
    {
      key: "inventory",
      label: "Inventory",
      icon: <FaCreditCard />,
      path: "/dashboard/inventory",
    },
    {
      key: "users",
      label: "Users",
      icon: <FaUser />,
      path: "/dashboard/userslist",
    },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-top">
        <div className="sidebar-logo">
          <img src={logo} alt="App Logo" />
        </div>

        <ul>
          {menuItems
            .filter((item) => visibleItems.includes(item.key))
            .map((item) => (
              <li key={item.key} onClick={() => navigate(item.path)}>
                {item.icon}
                <span>{item.label}</span>
              </li>
            ))}

          {/* Always show logout */}
          <li onClick={handleLogout}>
            <FaSignOutAlt className="icon" /> <span>Logout</span>
          </li>
        </ul>
      </div>

       <div className="powered-by">
        <span>Powered by</span>
        <img src={mindscraft} alt="Powered by Logo" />
      </div> 
    </div>
  );
};

export default Sidebar;
